<template>
    <div class="h-100">
        <ob1-cards :is-multiple="true" :is-inversed="isBlack" :with-composite-link="false">
            <img
                v-if="offer.technologyLogo"
                :src="offer.technologyLogo"
                alt="logo 5G Orange"
                class="logo-5g"
            >
            <strong
                v-if="showBanner(offer.banner)"
                class="ob1-tag ob1-tag-primary card-tag"
            >
                {{ offer.banner }}
            </strong>
            <div class="tile-content d-flex flex-column pt-2">
                <div class="title-wrapper px-1 px-xl-2 d-flex flex-column">
                    <p class="pt-xl-1 py-0 mb-0 fw-bold">
                        {{ getTitle(offer.name) + ' ' + blockedAndUnBlockedLabel }}
                    </p>
                    <h1 class="py-0 mb-0">
                        {{ getSubTitle(offer.name, offer.is5G) }}
                    </h1>
                </div>

                <div class="price-wrapper" :class="isShowOpenDiscountMessage ? 'my-1 mx-1 mx-xl-2 ps-1 bg-greige' : 'mb-0 px-1 px-xl-2'">
                    <ob1-prix-offre
                        :price="offer.price.price"
                        :duration="offer.price.duration"
                        :initial-price="offer.price.initialPrice"
                        :show-by-month="offer.price.showByMonth"
                        :show-from="offer.price.showFrom"
                        :show-promo-duration="offer.price.showPromoDuration"
                        :open-discount-message="offer.openDiscountMessage"
                        :price-details="offer.price.priceDetails"
                        custom-commitment="pt-0 d-block"
                        :is-inverse="isBlack && !isShowOpenDiscountMessage"
                        :is-compact="true"
                        :show-icon="false"
                    />
                </div>

                <div class="claim-wrapper">
                    <div v-if="offer.claims" class="mb-1 mx-1 mx-xl-2">
                        <template v-for="(claim, index) in offer.claims">
                            <offer-claim-cds :key="index" :claim="claim" :is-black="isBlack" />
                        </template>
                    </div>
                </div>

                <div v-if="advantageOfferMobileMessage" class="advantage-message-wrapper d-flex flex-row align-items-center px-1 px-xl-2">
                    <p class="mb-0 pt-0">
                        <span class="icon-Mobile-payment font-size-26" />
                    </p>
                    <p class="mb-0 pt-0">
                        <span class="fw-bold">{{ advantageOfferMobileMessage }}</span>
                    </p>
                </div>

                <div class="d-flex justify-content-center px-1 px-xl-2">
                    <offer-cta-with-device-popin
                        v-if="offer.addOfferDto"
                        class="mx-0 px-0 w-100"
                        :is-wide="true"
                        :is-primary="true"
                        :is-inverse="isBlack"
                        :label="ctaLabel"
                        :offer-name="offer.name"
                        :popin-id="'addOfferWithDevicePopIn-' + offer.idSeo"
                        :popin-ctas-dto="offer.addOfferDto.popinWithDeviceCdsDto"
                        :from-cds="true"
                        :is-sub="isSub"
                        :tracking-category="ctaTrackingCategory"
                        :tracking-label="getLabelToTmsFormat(offer.name)"
                    />
                    <offer-cta-with-device-popin
                        v-if="offer.addOfferWithAuthenticationDto"
                        class="mx-0 px-0 w-100"
                        :is-wide="true"
                        :is-primary="true"
                        :label="ctaLabel"
                        :offer-name="offer.name"
                        :popin-id="'addOfferWithAuthenticationAndDevicePopIn-' + offer.idSeo"
                        :popin-ctas-dto="offer.addOfferWithAuthenticationDto.popinWithDeviceCdsDto"
                        :from-cds="true"
                        :is-sub="isSub"
                        :tracking-category="ctaTrackingCategory"
                        :tracking-label="getLabelToTmsFormat(offer.name)"
                    />
                    <ob1-boutons
                        v-if="offer.addOfferInCartDto"
                        class="mx-0 px-0 w-100"
                        :is-button="true"
                        :is-primary="true"
                        :label="offer.addOfferInCartDto.label"
                        data-oevent-category="tuile_forfait_vsim"
                        data-oevent-action="ajouter_au_panier"
                        :data-oevent-label="offer.name"
                        @ob1-boutons-click.prevent="onAddOfferInCart()"
                    />
                </div>

                <div class="d-flex justify-content-center pb-1 px-1 px-xl-2">
                    <ob1-liens
                        is-button
                        :with-arrow="true"
                        :is-inverse="isBlack"
                        data-bs-toggle="modal"
                        :data-test-id="'btn-popin-detail-' + offer.idSeo"
                        modal-id="offer-details-popin"
                        :text="linkCdsDetailPageOrConfigureLabel"
                        :data-oevent-category="ctaTrackingCategory"
                        :data-oevent-action="getLabelToTmsFormat(offer.linkCdsDetailPageLabel)"
                        :data-oevent-label="getLabelToTmsFormat(offer.name)"
                        @ob1-liens-click="openOffersPopin(offer)"
                    />
                </div>
            </div>
        </ob1-cards>
    </div>
</template>

<script>
import OfferClaimCds from "./OfferClaimCds.vue";
import OfferCtaWithDevicePopin from "../../../common/offerdetails/OfferCtaWithDevicePopin.vue";

export default {
    components: {
        OfferCtaWithDevicePopin, OfferClaimCds
    },
    props: {
        offer: {
            type: Object,
            required: true
        },
        sectionId: {
            type: String,
            required: true
        },
        isSub: {
            type: Boolean,
            required: true
        },
        isFmr: {
            type: Boolean,
            required: true
        },
        isBlack: {
            type: Boolean,
            required: true
        },
        advantageOfferMobileMessage: {
            type: String,
            required: false,
            default: null
        },
    },
    computed: {
        linkCdsDetailPageOrConfigureLabel() {
            if (this.offer.blocked === undefined) {
                return this.offer.linkCdsDetailPageLabel;
            } else {
                return this.offer.linkCdsDetailPageAndConfigureLabel;
            }
        },
        blockedAndUnBlockedLabel() {
            if (this.offer.blocked === undefined) {
                return '';
            } else {
                return this.offer.blocked ? this.offer.miniOfferCdsTilesTypeBlocked : this.offer.miniOfferCdsTilesTypeUnBlocked;
            }
        },
        attributes() {
            return this.offer.attributes
        },
        ctaLabel() {
            return this.isSub ? this.offer.ctaCdsChoiceOfferAndMobileLabel : this.offer.ctaCdsChoiceOfferLabel
        },

        isShowOpenDiscountMessage() {
            return this.offer.openDiscountMessage !== undefined
        },
        ctaTrackingCategory() {
            return this.isSub ? 'tuile_forfait_vsub' : 'tuile_forfait_vsim'
        },
    },
    methods: {
        onAddOfferInCart() {
          this.$emit('add-offer-in-cart', this.offer.idSeo)
        },
        showBanner(banner) {
            return banner && banner !== '';
        },
        getSubTitle(str, is5G) {
            let strWithOut5G = is5G ? str.substring(str.length-2, 0) : str;
            let match = strWithOut5G.match(/\d+/);
            return strWithOut5G.substring(str.indexOf(match ? parseInt(match[0], 10) : '')).trim();
        },
        getTitle(str) {
            let match = str.match(/\d+/);
            return str.substring(0, str.indexOf(match ? parseInt(match[0], 10) : '')).trim();
        },
        openOffersPopin(offer) {
            Tms.link({category: 'voir_le_detail', action: offer.name, label: 'vers_popin_offres'});
            //Créer un datalayer propre à la popin
            if (!window.o_utagview || !tmsData) return;
            let tmsDataPopin = {... tmsData};
            tmsDataPopin.id_tracking = "jsomEXnY";
            tmsDataPopin.titre_page = "overlay_" + stripAccents(offer.name).split(' ').join('_');
            tmsDataPopin.type_page = "overlay_fiche_forfait";
            tmsDataPopin.offre_prix_ttc = offer.price.price.toString();
            tmsDataPopin.offre_type = this.isFmr ? "forfait_postpaid_fmo_orange" : "forfait_postpaid_fm_orange";
            tmsDataPopin.offre_libelle = offer.name;
            tmsDataPopin.offre_modele = offer.name;
            tmsDataPopin.offre_qte = 1;
            tmsDataPopin.offre_id = offer.variationCode;
            Tms.view(tmsDataPopin);
            this.$emit('selected-offer-details', offer);
        },
        getLabelToTmsFormat(label) {
            let blockedUnBlockedLabel = '';
            if (this.offer.blocked !== undefined) {
                blockedUnBlockedLabel = this.offer.blocked ? '_bloque' : '_non_bloque';
            }

            return stripAccents(label).split(' ').join('_') + blockedUnBlockedLabel;
        },
    },
}
</script>
<style lang="scss">
.logo-5g {
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    object-fit: cover;
    object-position: 14px -14px;
}
.label-5g {
    position: absolute;
    top: 6px;
    right: 6px;
}

//Une classe ajoutée provisoir pour le tag(banner)
//dans une card non pris en compte par ob1
.card-tag {
    position: absolute;
    top: -.0625rem;
    left: -.0625rem;
}

//Une classe ajoutée provisoir pour la partie promo du forfait
.ob1-price .ob1-price-promo-duration {
    display: inline;
}

</style>
